import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

/**
 * GenerateFolhaPagamentoColumnsDef
 */

type Props = {
  onActionViewItem: (idFolhaPagamento: number, openNewTab: boolean) => void;
  onActionEdit: (idFolhaPagamento: number, openState: boolean) => void;
  onActionDelete: (idFolhaPagamento: number, openState: boolean) => void;
  onActionCopy: (idFolhaPagamento: number, openState: boolean) => void;
};

export const GenerateFolhaPagamentoColumnsDef = ({
  onActionViewItem,
  onActionEdit,
  onActionDelete,
  onActionCopy,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Detalhada";
      case 0:
        return "Simples";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "red";
      case 0:
        return "green";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Detalhada";
      case 0:
        return "Simples";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipoFolha",
      filterable: false,
      headerName: "Tipo",
      minWidth: 105,
      width: 105,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemStatusTitle(params.value ? 1 : 0)}
            color={computeItemStatusColor(params.value ? 1 : 0)}
            description={computeItemStatusDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "nrFolhaPagamento",
      filterable: false,
      headerName: "Nº",
      width: 75,
      minWidth: 75,
      sortable: false,
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data Cadastro",
      width: 100,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "dataReferencia",
      filterable: false,
      headerName: "Data Pagamento",
      width: 100,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      sortable: false,
      valueGetter: (_, row) => { return row['idFolhaPagamento'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={e => {
              if (e.button === 1) {
                onActionViewItem(value, true);
              } else {
                onActionViewItem(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Itens
          </Button>
        );
      },
    },
    {
      field: 'idFolhaPagamento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: 'idFolhaPagamentoCopia',
      sortable: false,
      filterable: false,
      headerName: 'Copiar',
      width: 65,
      valueGetter: (_, row) => row['idFolhaPagamento'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionCopy(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}